import { SelectShippingStepId, SelectShippingStepType } from "../../SelectShippingStep.types";
import { selectShippingStepLabels } from "../../selectShippingStepLabels";
import { AddShipmentDetails } from "./AddShipmentDetails";

export const addShipmentDetailStep: SelectShippingStepType = {
  id: SelectShippingStepId.ADD_SHIPMENT_DETAILS,
  title: selectShippingStepLabels.addShipmentDetails,
  component: AddShipmentDetails,
};
